import React, { useState } from "react";
import emailjs from "emailjs-com";
import { IoClose } from "react-icons/io5"; // Import ikon X

const CareerForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    position: "",
    phone: "",
    email: "",
    // address: "",
    resume: null, // Untuk menyimpan file
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
      if (allowedTypes.includes(file.type)) {
        setFormData({ ...formData, resume: file });
      } else {
        alert("Hanya file PDF, DOC, atau DOCX yang diperbolehkan!");
        e.target.value = ""; // Reset input file
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceID = "YOUR_SERVICE_ID";
    const templateID = "YOUR_TEMPLATE_ID";
    const userID = "YOUR_USER_ID";

    const formDataObj = new FormData();
    formDataObj.append("name", formData.name);
    formDataObj.append("position", formData.position);
    formDataObj.append("phone", formData.phone);
    formDataObj.append("email", formData.email);
    // formDataObj.append("address", formData.address);
    if (formData.resume) {
      formDataObj.append("resume", formData.resume);
    }

    emailjs.sendForm(serviceID, templateID, formDataObj, userID)
      .then((response) => {
        console.log("Email berhasil dikirim!", response.status, response.text);
        alert("Lamaran berhasil dikirim!");
        onClose(); // Tutup pop-up setelah submit
      })
      .catch((error) => {
        console.error("Gagal mengirim email:", error);
        alert("Terjadi kesalahan. Silakan coba lagi.");
      });
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm z-50 p-4"
      onClick={onClose}
    >
      {/* Kontainer Form */}
      <div
        className="bg-white p-6 md:p-8 rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-auto relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Tombol X di kanan atas */}
        <button
          type="button"
          onClick={onClose}
          aria-label="Tutup"
          className="absolute top-4 right-4 h-9 w-9 flex items-center justify-center rounded-full text-slate-500 hover:bg-slate-100 hover:text-brand text-xl transition-colors duration-200 cursor-pointer"
        >
          <IoClose />
        </button>

        <h2 className="text-xl font-bold mb-6 text-center text-brand">
          Isi Data Diri
        </h2>
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="mb-4">
            <label className="field-label">Nama Lengkap</label>
            <input
              type="text"
              name="name"
              placeholder="Nama Lengkap"
              value={formData.name}
              onChange={handleChange}
              className="input-field"
              required
            />
          </div>
          <div className="mb-4">
            <label className="field-label">Posisi yang Dilamar</label>
            <input
              type="text"
              name="position"
              placeholder="Posisi yang dilamar"
              value={formData.position}
              onChange={handleChange}
              className="input-field"
              required
            />
          </div>
          <div className="mb-4">
            <label className="field-label">Nomor Telepon</label>
            <input
              type="tel"
              name="phone"
              placeholder="Nomor Telepon"
              value={formData.phone}
              onChange={handleChange}
              className="input-field"
              required
            />
          </div>
          <div className="mb-4">
            <label className="field-label">Email</label>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="input-field"
              required
            />
          </div>
          {/* <div className="mb-4">
            <label className="field-label">Alamat</label>
            <textarea
              name="address"
              placeholder="Alamat"
              value={formData.address}
              onChange={handleChange}
              className="input-field"
              required
            />
          </div> */}
          <div className="mb-6">
            <label className="field-label">Upload CV/Resume (PDF/DOC)</label>
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={handleFileChange}
              className="input-field file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:bg-brand/10 file:text-brand file:font-semibold file:cursor-pointer cursor-pointer"
              required
            />
          </div>
          <div className="flex justify-end">
            <button
              type="submit"
              className="btn-primary w-full"
            >
              Kirim
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CareerForm;
